import type { FunctionComponent } from "react";

import { useSearchContext } from "~/components/search/contexts";
import { DropdownMenu } from "~/components/search/search-result-panel/components/dropdown-menu";
import { SortingMenuContainer } from "~/components/search/search-result-panel/search-result-list/sorting-menu/style";
import type { ArticlesSearchOrderByInput } from "~/queries/__generated__/searchArticleResultPaginationQuery.graphql";

import { DefaultSortingOption, SortingOptions } from "./const";

type Props = {
  className?: string;
};

export const SearchResultListSortingMenu: FunctionComponent<Props> = ({ className }) => {
  const { orderBy, setOrderBy } = useSearchContext();
  const handleOnSortingChanged = (selectedOrderBy?: ArticlesSearchOrderByInput) => {
    selectedOrderBy &&
      setOrderBy?.({
        ...selectedOrderBy,
      });
  };

  const selectedSortingOption = orderBy ?? DefaultSortingOption.value;

  return (
    <SortingMenuContainer className={className}>
      <DropdownMenu
        options={SortingOptions}
        selectedOptionValue={selectedSortingOption}
        onOptionSelect={handleOnSortingChanged}
      />
    </SortingMenuContainer>
  );
};

SearchResultListSortingMenu.displayName = "SearchResultListSortingMenu";
